/**
 * @file index.tsx
 *
 * @fileoverview Renders a list of messages on the screen from the global state.
 * Components can register messages to the global store and they will get rendered here.
 */

import React from 'react';
import { Message } from '~/jobiqo/models/app';
import { MasqueradedMessage } from '~/jobiqo/components/MasqueradedMessage';
import { MessageAlert } from '~/vcl/atoms/02-messages/01-alert';

interface MessageListProps {
  /**
   * All the messages to render
   */
  messages: Message[];
  /**
   * Dispatch function to call when a message is deleted.
   */
  dispatch: any;
}

export const MessageList = ({ dispatch, messages }: MessageListProps) => {
  return (
    <>
      <MasqueradedMessage />
      {messages &&
        messages.map((message, index) => (
          <MessageAlert
            alertStyle={message.type}
            key={index}
            onClose={() =>
              dispatch({
                type: 'removeMessage',
                message,
              })
            }
          >
            <div data-test-id={message?.test_id ?? message?.id}>
              {message.text}
            </div>
          </MessageAlert>
        ))}
    </>
  );
};
